import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CheckoutShippingUSAddressValidateState from "@tKgpco/Store/Data/CheckoutShipping/CheckoutShippingUSAddressValidateState";
import { Draft } from "immer";

const initialState: CheckoutShippingUSAddressValidateState = {
    isLoading: false,
    USvalidateErrorMessage: "",
};
export const reducer = {
    "Custom/CheckoutShipping/UsAddressValidateLoading": (draft: Draft<CheckoutShippingUSAddressValidateState>) => {
        draft.isLoading = true;
    },
    "Custom/CheckoutShipping/UsAddressValidateError": (
        draft: Draft<CheckoutShippingUSAddressValidateState>,
        action: { errorMessage: string },
    ) => {
        draft.USvalidateErrorMessage = action.errorMessage;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
